import { Button, Divider, Flex, Layout, notification, Select, Space, Table, Tag } from 'antd';
import { API } from '../../../api';
import { use, useEffect, useState } from 'react';
import { render } from '@testing-library/react';
import { SortingEdit } from './SortingEdit';

export const SortingView = () => {
  const [state, changeState] = useState({ open: false, chuteCode: 0 });
  const [selectedPlan, changePlan] = useState('default_1');
  const removeBranch = async (branch: any) => {
    try {
      await API.post({ apiVersion: 'api' })('/sorter/branch/remove', {
        machineCode: branch.machineCode,
        branchNo: branch.branch.no,
      });
      notification.success({
        message: 'Амжилттай',
        description: '',
        duration: 300,
        placement: 'topRight',
      });
      fetchData(selectedPlan);
    } catch (e) {}
  };
  const columns = [
    {
      title: 'Гаралт',
      dataIndex: 'chuteCode',
      key: 'chuteCode',
    },
    {
      title: 'Салбарууд',
      dataIndex: 'branchList',
      render: (branchList: any) => {
        return (
          <Flex gap="4px 0" wrap>
            {branchList.map((branch: any) => (
              <Tag
                onClose={(e) => {
                  e.preventDefault();
                  removeBranch(branch);
                }}
                closable
                key={branch.branch.cd}
                color="blue"
              >
                {branch.branch.name}
              </Tag>
            ))}
          </Flex>
        );
      },
      key: 'description',
    },
    {
      title: 'Нэмэх',
      render: (data: any) => {
        return (
          <Button
            onClick={() => changeState({ open: true, chuteCode: data.chuteCode })}
            type="primary"
          >
            Салбар нэмэх
          </Button>
        );
      },
    },
  ];
  const [data, setData] = useState<any>({ loading: true, data: [] });
  const [plans, changePlans] = useState<any>({ loading: false, data: [] });
  useEffect(() => {
    fetchPlanList();
  }, []);
  useEffect(() => {
    fetchData(selectedPlan);
  }, [selectedPlan]);
  const fetchData = async (plan: String) => {
    try {
      setData({ loading: true, data: [] });
      const response = await API.get({ apiVersion: 'api' })(`/sorter/list?machineCode=${plan}`);
      setData({ loading: false, data: response.result.data });
    } catch (e) {
      console.log(e);
    }
  };
  const fetchPlanList = async () => {
    try {
      setData({ loading: true, data: [] });
      const response = await API.get({ apiVersion: 'api' })('/sorter/plan/list?aa=bb');
      changePlans({ loading: false, data: response.result });
    } catch (e) {
      console.log(e);
    }
  };
  return (
    <Layout.Content style={{ margin: '24px 16px 0' }}>
      <h3>Ангилагч</h3>
      <Divider />
      <div className="search-area">
        <Space wrap>
          <Select
            value={selectedPlan}
            onChange={(e) => changePlan(e)}
            style={{ width: 250 }}
            placeholder="Төрөл"
            allowClear
          >
            {plans.data.map((plan: any) => (
              <Select.Option key={plan.machineCode} value={plan.machineCode}>
                {plan.machineCode}
              </Select.Option>
            ))}
          </Select>
        </Space>
        <Divider />

        {/* <Space wrap>
        <Radio.Group>
          <Radio.Button value="large">Нийт-1</Radio.Button>
          <Radio.Button value="default">Хугацаа дууссан-1</Radio.Button>
          <Radio.Button value="small">Өнөөдөр хугацаа дуусах-1</Radio.Button>
        </Radio.Group>
        <Radio.Group>
          <Radio.Button value="large">Нийт-1</Radio.Button>
          <Radio.Button value="default">Салбарт илгээсэн</Radio.Button>
          <Radio.Button value="small">Хүргэлтэд гарсан</Radio.Button>
        </Radio.Group>
      </Space> */}
        <Table columns={columns} dataSource={data.data} />
        <SortingEdit
          chuteCode={state.chuteCode}
          open={state.open}
          onCancel={() => changeState({ open: false, chuteCode: 0 })}
          onOk={() => {
            changeState({ open: false, chuteCode: 0 });
            fetchData(selectedPlan);
          }}
        />
      </div>
    </Layout.Content>
  );
};
